import { render, staticRenderFns } from "./ButtonTemplate.vue?vue&type=template&id=0d955ef6&scoped=true"
import script from "./ButtonTemplate.vue?vue&type=script&lang=js"
export * from "./ButtonTemplate.vue?vue&type=script&lang=js"
import style0 from "./ButtonTemplate.vue?vue&type=style&index=0&id=0d955ef6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d955ef6",
  null
  
)

export default component.exports